import Device			from "../device.js";
import TMC5041			from "./tmc5041.js";

export default class Module extends Device {
  constructor() {       
    super();
    this.id = "";
    this.status = "uninitialized";
    this.rpm = 0;
    this.velocity = 0;
    this.mlh = 0;
    this.sumML = 0;    
  }
  
  async initialize(bus, name, motorid) {
    try {
      if (bus instanceof TMC5041)
        this.__bus = bus;
      else 
        throw TypeError("invalid bus type");
            
      this.id = "tmc5041";
      this.rpm = 0;
      this.mlh = 0;
      this.velocity = 0;
      this.name = name;
      
      this.status = "OK";

      this.usbProductName = "tmc5041";
      this.usbSerialNumber = motorid;
      this.motorid = motorid;

    } catch(e) {
      this.id = "-";
      this.status = "Failed: "+e.message;
      throw e;
    }
  }

  async update() {
  }

  async setVelocity(value) {
    this.__bus.setVelocitySync(this.motorid, value);
    this.velocity = value;
  }
  
  async RM_setVelocity(value) {
    await this.setVelocity(value);
  }    
  
  logData(logData) {
    logData.append(`${this.name}_velocity`, this.velocity);
  }  
  
  toJSON() {
    return({
      id: this.id,
      usbProductName: this.usbProductName,
      usbSerialNumber: this.usbSerialNumber,            
      status: this.status,
      name: this.name,
      errors: this.errors,
      warnings: this.warnings,
      velocity: this.velocity,
      sp: this.mlh,
      pv: this.mlh
    });
  }

}